import React from 'react';
import { Link } from 'react-router-dom';
import MultiProviderLogin from './MultiProviderLogin';

const SubscriptionAuthGate: React.FC = () => {
  return (
    <div className="min-h-[75vh] flex items-center justify-center px-4 py-12 animate-fade-in">
      <div className="max-w-md w-full bg-dk-900/90 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-xl shadow-2xl shadow-black/80 text-center relative overflow-hidden">
        {/* Cyber-Professional ambient glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-1 bg-gradient-to-r from-transparent via-azure-500 to-transparent"></div>

        {/* Security / Tier Shield Icon */}
        <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-azure-500/10 border border-azure-500/30 flex items-center justify-center text-azure-400 shadow-lg shadow-azure-500/10">
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>

        {/* Status Capsule */}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-azure-500/10 border border-azure-500/20 mb-4">
          <span className="w-1.5 h-1.5 rounded-full bg-azure-400 animate-pulse"></span>
          <span className="text-[9px] font-black uppercase tracking-[0.25em] text-azure-400">
            Authentication Required
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight text-white mb-3">
          Sign In to Access Pricing & Plans
        </h2>

        {/* Description aligned with Explorer Baseline Architecture */}
        <p className="text-xs text-gray-300 leading-relaxed mb-6 font-medium">
          Synclothe operates on a tiered intelligence model. Sign in with GitHub or Microsoft to instantly claim your complimentary <strong className="text-white font-bold">Explorer (Tier 1)</strong> account. From your authenticated workspace, you can review subscription tiers and upgrade to Standard or Premium at any time.
        </p>

        {/* Multi-Provider Auth Buttons */}
        <div className="mb-6">
          <MultiProviderLogin />
        </div>

        {/* Navigation fallback */}
        <div className="pt-2 border-t border-white/5">
          <Link
            to="/"
            className="text-[10px] font-bold uppercase tracking-widest text-gray-400 hover:text-white transition-colors inline-flex items-center gap-1.5"
          >
            ← Return to Styling Engine
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionAuthGate;
